import React, { useEffect, useState } from 'react';
import { useAppContext } from '../../context/appContext';
import Wrapper from '../../assets/wrappers/DashboardFormPage';
import styled from 'styled-components';
import { Alert } from '../../components';
import moment from 'moment';
import ConfirmationModal from '../../components/ConfirmationModalDelete';

const Wrapper2 = styled.div`
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
  }

  th, td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }

  th {
    background-color: #f4f4f4;
  }

  tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  /* Adjust table for smaller screens */
  @media (max-width: 768px) {
    table {
      display: block;
      width: 100%;
      overflow-x: auto;
      white-space: nowrap;
    }

    th, td {
      font-size: 0.8rem;
      padding: 8px;
    }
  }

  @media (max-width: 480px) {
    th, td {
      font-size: 0.75rem;
      padding: 5px;
    }
  }

  .pagination {
    margin-top: 2rem;
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    align-items: center;
  }

  .pagination button {
    padding: 0.5rem 1rem;
    border: 1px solid #ddd;
    background-color: #fff;
    cursor: pointer;
    border-radius: 4px;
  }

  .pagination button:disabled {
    background-color: #f4f4f4;
    cursor: not-allowed;
  }
`;

const AllAccidents = () => {
  const {
    getAccidents,
    accidents = [],
    isLoading,
    showAlert,
    error,
    totalAccidents,
    numOfPagesAccidents,
    deleteAccident,
    clearAlert,
  } = useAppContext();
  const [currentPage, setCurrentPage] = useState(1);
  const [showConfirmation, setShowConfirmation] = useState(false); // State to control the modal
  const [accidentToDelete, setAccidentToDelete] = useState(null); // Store the user to delete
  const [isHoveredF, setIsHoveredF] = useState(false); // State to track hover
  const [isHoveredL, setIsHoveredL] = useState(false); // State to track hover


  // Fetch users only on initial load
  useEffect(() => {
    if (!isLoading && accidents.length === 0) {
      getAccidents(currentPage); // Fetch users only on initial load
    }
  }, [isLoading, accidents.length, getAccidents]);

  // Handle next page
  const handleNextPage = () => {
    if (currentPage < numOfPagesAccidents) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage); // Update currentPage state
      getAccidents(nextPage); // Fetch users for the next page
    }
  };

  // Handle previous page
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      setCurrentPage(prevPage); // Update currentPage state
      getAccidents(prevPage); // Fetch users for the previous page
    }
  };

  // Handle last page
  const handleLastPage = () => {
    if (currentPage < numOfPagesAccidents) {
      setCurrentPage(numOfPagesAccidents); // Update currentPage state
      getAccidents(numOfPagesAccidents); // Fetch users for the next page
    }
  };

  // Handle first page
  const handleFirstPage = () => {
    if (currentPage > 1) {
      setCurrentPage(1); // Update currentPage state
      getAccidents(1); // Fetch users for the next page
    }
  };

  // Handle delete user
  const handleDeleteAccident = (_id) => {
    setAccidentToDelete(_id); // Set the user to delete
    setShowConfirmation(true); // Show the confirmation modal
  };

  // Handle confirmation
  const handleConfirmDelete = async () => {
    setShowConfirmation(false); // Hide the modal
    if (accidentToDelete) {
      await deleteAccident(accidentToDelete); // Call deleteUser function
      setCurrentPage(1); // Reset currentPage to 1
      getAccidents(1); // Fetch users for the first page
    }
  };

  // Handle cancellation
  const handleCancelDelete = () => {
    setShowConfirmation(false); // Hide the modal
    setAccidentToDelete(null); // Clear the user to delete
  };

  // If still loading, show a loading message or spinner
  if (isLoading) {
    return <p>Chargement des accidents...</p>;
  }

  // Handle errors if any
  if (error) {
    return <Alert message={error} onClose={clearAlert} />;
  }

  // Once loading is done, render the table with users
  return (
    <Wrapper>
      <Wrapper2>
        <h3>Tous les accidents</h3>
        {showAlert && <Alert message={showAlert} onClose={clearAlert} />}
        <table>
          <thead>
            <tr>
              <th>Numéro</th>
              <th>Nom</th>
              <th>Prénom</th>
              <th>Téléphone</th>
              <th>Date d'ajout</th>
              <th>Date d'accident</th>
              <th>Date de naissance</th>
              <th>Genre</th>
              <th>Type d'accident</th>
              <th>Provenance</th>
              <th>Gouvernerat</th>
              <th>Actions</th>

            </tr>
          </thead>
          <tbody>
            {accidents.length > 0 ? (
              accidents.map((accident, index) => (
                <tr key={accident._id}>
                  <td>{(currentPage - 1) * 20 + index + 1}</td>
                  <td>{accident.nom}</td>
                  <td>{accident.prenom}</td>
                  <td>{accident.tel}</td>
                  <td>{moment(accident.createdAt).format('DD/MM/YYYY')}</td>
                  <td>{moment(accident.dateAccident).format('DD/MM/YYYY')}</td>
                  <td>{moment(accident.dateNaissance).format('DD/MM/YYYY')}</td>
                  <td>{accident.genre}</td>
                  <td>{accident.accidentType}</td>
                  <td>{accident.provenance}</td>
                  <td>{accident.gouvernerat}</td>

                  <td>
                    <button
                      onClick={() => handleDeleteAccident(accident._id)}
                      className={'btn btn-danger'}
                     >
                      Supprimer
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7">Aucun accident trouvé</td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination Controls */}
        <div className="pagination">
          <button
            onClick={handleFirstPage}
            disabled={currentPage === 1}
            style={{
              border: 'none', // Remove the border
              background: 'none', // Remove the background
              padding: 0, // Remove padding
              font: 'inherit', // Use the same font as the parent
              color: currentPage === 1 ? '#ccc' : isHoveredF ? '#007bff' : '#000', // Black by default, blue on hover
              textDecoration: isHoveredF ? 'underline' : 'none', // Underline only on hover
              cursor: currentPage === 1 ? 'not-allowed' : 'pointer', // Change cursor based on disabled state
              transition: 'color 0.2s ease, text-decoration 0.2s ease', // Smooth transition for hover effect
              fontSize: '1.2em', // Slightly larger font size for better visibility
            }}
            onMouseEnter={() => setIsHoveredF(true)} // Handle hover in
            onMouseLeave={() => setIsHoveredF(false)} // Handle hover out
          >
            &lt;&lt; {/* HTML entity for >> */}
          </button>
          <button onClick={handlePreviousPage} disabled={currentPage === 1}>
            Précédent
          </button>
          <span>
            Page {currentPage} sur {numOfPagesAccidents}
          </span>
          <button onClick={handleNextPage} disabled={currentPage === numOfPagesAccidents}>
            Suivant
          </button>
          <button
            onClick={handleLastPage}
            disabled={currentPage === numOfPagesAccidents}
            style={{
              border: 'none', // Remove the border
              background: 'none', // Remove the background
              padding: 0, // Remove padding
              font: 'inherit', // Use the same font as the parent
              color: currentPage === numOfPagesAccidents ? '#ccc' : isHoveredL ? '#007bff' : '#000', // Black by default, blue on hover
              textDecoration: isHoveredL ? 'underline' : 'none', // Underline only on hover
              cursor: currentPage === numOfPagesAccidents ? 'not-allowed' : 'pointer', // Change cursor based on disabled state
              transition: 'color 0.2s ease, text-decoration 0.2s ease', // Smooth transition for hover effect
              fontSize: '1.2em', // Slightly larger font size for better visibility
            }}
            onMouseEnter={() => setIsHoveredL(true)} // Handle hover in
            onMouseLeave={() => setIsHoveredL(false)} // Handle hover out
          >
            &gt;&gt; {/* HTML entity for >> */}
          </button>
        </div>

        {/* Custom Confirmation Modal */}
        {showConfirmation && (
          <ConfirmationModal
            message={
              <span>
                <strong>Supprimer</strong> cet accident ?
              </span>
            }
            onConfirm={handleConfirmDelete}
            onCancel={handleCancelDelete}
          />
        )}
      </Wrapper2>
    </Wrapper>
  );
};

export default AllAccidents;